// Motion presets for consistent animations throughout the app
export const motionPresets = {
  // Pop animation for buttons and interactive elements
  pop: {
    initial: { scale: 0.95, opacity: 0 },
    animate: { 
      scale: 1, 
      opacity: 1,
      transition: { 
        type: 'spring', 
        stiffness: 260, 
        damping: 20,
        duration: 0.12
      }
    },
    exit: { 
      scale: 0.95, 
      opacity: 0,
      transition: { duration: 0.1 }
    }
  },

  // Fade up animation for content sections
  fadeUp: {
    initial: { y: 20, opacity: 0 },
    animate: { 
      y: 0, 
      opacity: 1,
      transition: { 
        duration: 0.3, 
        ease: 'easeOut'
      }
    },
    exit: { 
      y: -10, 
      opacity: 0,
      transition: { duration: 0.2 }
    }
  },

  // Slide in from left for sidebar panels
  slideInLeft: {
    initial: { x: -30, opacity: 0 },
    animate: { 
      x: 0, 
      opacity: 1,
      transition: { 
        duration: 0.3, 
        ease: 'easeOut',
        delay: 0.1
      }
    },
    exit: { 
      x: -20, 
      opacity: 0,
      transition: { duration: 0.2 }
    }
  },

  // Scale and fade for modal overlays
  modalOverlay: {
    initial: { opacity: 0 },
    animate: { 
      opacity: 1,
      transition: { duration: 0.2 }
    },
    exit: { 
      opacity: 0,
      transition: { duration: 0.15 }
    }
  },

  // Modal content animation
  modalContent: {
    initial: { scale: 0.95, opacity: 0, y: 20 },
    animate: { 
      scale: 1, 
      opacity: 1, 
      y: 0,
      transition: { 
        type: 'spring', 
        stiffness: 300, 
        damping: 24,
        delay: 0.1
      }
    },
    exit: { 
      scale: 0.95, 
      opacity: 0, 
      y: 10,
      transition: { duration: 0.15 }
    }
  },

  // Stagger children animation
  stagger: {
    animate: {
      transition: {
        staggerChildren: 0.1
      }
    }
  },

  // Hover lift effect
  hoverLift: {
    initial: { y: 0 },
    whileHover: { 
      y: -4,
      transition: { 
        type: 'spring', 
        stiffness: 400, 
        damping: 25 
      }
    },
    whileTap: { 
      y: -2,
      transition: { duration: 0.1 }
    }
  },

  // Tap scale effect
  tapScale: {
    whileTap: { 
      scale: 0.95,
      transition: { duration: 0.1 }
    }
  },

  // Float animation for decorative elements
  float: {
    animate: {
      y: [-2, 2, -2],
      transition: {
        duration: 4,
        repeat: Infinity,
        ease: 'easeInOut'
      }
    }
  },

  // Glow pulse for active states
  glowPulse: {
    animate: {
      boxShadow: [
        '0 0 20px rgba(0, 124, 240, 0.3)',
        '0 0 30px rgba(0, 124, 240, 0.6)',
        '0 0 20px rgba(0, 124, 240, 0.3)'
      ],
      transition: {
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }
    }
  },

  // Gradient animation for backgrounds
  gradientShift: {
    animate: {
      backgroundPosition: ['0% 50%', '100% 50%', '0% 50%'],
      transition: {
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut'
      }
    }
  }
};

// Easing functions
export const easings = {
  easeOut: [0.25, 0.46, 0.45, 0.94],
  easeSpring: [0.175, 0.885, 0.32, 1.275],
  bounceSoft: [0.25, 0.46, 0.45, 0.94]
};

// Common transition configurations
export const transitions = {
  fast: { duration: 0.12, ease: 'easeOut' },
  medium: { duration: 0.3, ease: 'easeOut' },
  slow: { duration: 0.5, ease: 'easeOut' },
  spring: { type: 'spring', stiffness: 260, damping: 20 },
  bouncy: { type: 'spring', stiffness: 400, damping: 10 }
};

// Parallax scroll animation
export const parallaxScroll = (offset = 0.5) => ({
  scrollY: {
    transform: `translateY(${offset}px)`,
    transition: { duration: 0 }
  }
});

// Canvas drag animations
export const canvasDrag = {
  drag: true,
  dragConstraints: { left: 0, right: 0, top: 0, bottom: 0 },
  dragElastic: 0.1,
  whileDrag: { 
    scale: 1.02,
    rotate: 2,
    transition: { duration: 0.1 }
  }
};

export default motionPresets;